import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a63564f0")

_pushScopeId("data-v-a63564f0")
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "fill_out_order" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "order_tit" }, [
  /*#__PURE__*/_createTextVNode("받는 사람의 "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 휴대폰 번호를 입력해 주세요.")
], -1)
const _hoisted_6 = { class: "guide_txt" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("받는 사람 ")
const _hoisted_8 = { class: "inp_bx" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "phone_number",
  class: "blind"
}, "검색", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "지우기", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  for: "phone_number",
  class: "blind"
}, "검색", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "지우기", -1)
const _hoisted_13 = { class: "box_gift_btn" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", null, "받는 사람 추가하기", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "연락처 불러오기", -1)
const _hoisted_16 = { class: "btn_area_wrap" }
const _hoisted_17 = { class: "btn_area" }
const _hoisted_18 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_19 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, [
  /*#__PURE__*/_createTextVNode("이미 추가된 번호입니다. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 동일한 번호는 추가할 수 없습니다.")
], -1)
const _hoisted_20 = { class: "sub_txt" }
const _hoisted_21 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "휴대폰 번호를 정확히 입력해주세요.", -1)
const _hoisted_22 = { class: "txt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_component = _resolveComponent("header-component")
  const _component_popup_component = _resolveComponent("popup-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "wrap",
      class: ["wrap", {app_view: _ctx.isApp}]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_header_component, null, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("strong", _hoisted_6, [
            _hoisted_7,
            _createVNode("span", null, "(" + _toDisplayString(_ctx.receivers.length) + "/" + _toDisplayString(_ctx.giftReceiverLimitCount) + "명)", 1)
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver, index) => {
            return (_openBlock(), _createBlock("div", {
              key: receiver.phoneNumber
            }, [
              _createVNode("span", _hoisted_8, [
                _hoisted_9,
                _createVNode("input", {
                  type: "tel",
                  class: "inp",
                  value: receiver.displayedName,
                  disabled: ""
                }, null, 8, ["value"]),
                _createVNode("button", {
                  type: "button",
                  class: "btn_del",
                  onClick: ($event: any) => (_ctx.removeReceiver(index))
                }, [
                  _hoisted_10
                ], 8, ["onClick"])
              ])
            ]))
          }), 128)),
          _withDirectives(_createVNode("span", {
            class: ["inp_bx", {'is_focus': _ctx.isTypingMode}]
          }, [
            _hoisted_11,
            _withDirectives(_createVNode("input", {
              ref: "phoneNumber",
              type: "tel",
              id: "phone_number",
              class: "inp",
              placeholder: "휴대폰 번호 '-' 없이 입력",
              onFocusin: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.initInputStatus && _ctx.initInputStatus(...args))),
              onFocusout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewReceiverForFocusOut && _ctx.addNewReceiverForFocusOut(...args))),
              onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.addNewReceiverForEnterKey && _ctx.addNewReceiverForEnterKey(...args)), ["enter"])),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.inputPhoneNumber = $event))
            }, null, 544), [
              [_vModelText, _ctx.inputPhoneNumber]
            ]),
            _withDirectives(_createVNode("button", {
              type: "button",
              class: "btn_del",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearInputPhoneNumber && _ctx.clearInputPhoneNumber(...args)))
            }, [
              _hoisted_12
            ], 512), [
              [_vShow, _ctx.hasInputPhoneNumber]
            ])
          ], 2), [
            [_vShow, _ctx.showReceiverInput]
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode("button", {
              type: "button",
              class: "gift_btn add_receiver",
              onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openReceiverInput && _ctx.openReceiverInput(...args)), ["prevent"]))
            }, [
              _hoisted_14
            ]),
            (_ctx.showOpenContactsAppButton)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  class: "gift_btn fetch_contact",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openContacts && _ctx.openContacts(...args)))
                }, [
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _withDirectives(_createVNode("button", {
              type: "button",
              class: ["btn btn_buy", {'is_active': _ctx.hasReceiver}],
              disabled: !_ctx.hasReceiver,
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.goToWriteMessage && _ctx.goToWriteMessage(...args)))
            }, " 선물하기(" + _toDisplayString(_ctx.receivers.length) + "명) ", 11, ["disabled"]), [
              [_vShow, !_ctx.isTypingMode||!_ctx.isAndroid]
            ])
          ])
        ])
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_18, null, 512), [
      [_vShow, _ctx.showDimmed]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleAlreadyAddedPhoneNumberPopup }, {
      default: _withId(() => [
        _hoisted_19,
        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.duplicatePhoneNumber), 1)
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showAlreadyAddedPhoneNumberPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleInvalidPhoneNumberPopup }, {
      default: _withId(() => [
        _hoisted_21
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showInvalidPhoneNumberPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, { onConfirm: _ctx.toggleGiftReceiverLimitPopup }, {
      default: _withId(() => [
        _createVNode("strong", _hoisted_22, _toDisplayString(_ctx.giftReceiverLimitCount) + "명까지 설정할 수 있습니다.", 1)
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showGiftReceiverLimitPopup]
    ])
  ], 64))
})